import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Store } from "lucide-react";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function Register() {
  const { register, formatApiError } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    owner_name: "",
    mobile: "",
    email: "",
    shop_name: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\d{10,12}$/.test(form.mobile.replace(/\D/g, ""))) {
      toast.error("Sahi mobile number daalain");
      return;
    }
    setLoading(true);
    try {
      const v = await register(form);
      // Verification-pending flow — direct user to AuthModal verify step via Landing
      toast.success(`Verification code: ${v.code} — WhatsApp pe send karein.`);
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-md p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6" data-testid="register-brand">
          <Logo size={44} priority />
          <div>
            <div className="font-display text-xl font-bold">Create your shop</div>
            <div className="text-xs text-slate-500">HisaabPro pe apna installment business aaj hi shuru karen.</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="space-y-2">
            <Label htmlFor="owner_name">Full name</Label>
            <Input
              id="owner_name"
              required
              minLength={2}
              value={form.owner_name}
              onChange={(e) => setForm({ ...form, owner_name: e.target.value })}
              placeholder="Ahmed Khan"
              data-testid="register-owner-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="mobile">Mobile number</Label>
            <Input
              id="mobile"
              required
              inputMode="numeric"
              value={form.mobile}
              onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              placeholder="03001234567"
              data-testid="register-mobile-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email address</Label>
            <Input
              id="email"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="owner@shop.com"
              data-testid="register-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="shop_name">Business / shop name</Label>
            <Input
              id="shop_name"
              required
              minLength={2}
              value={form.shop_name}
              onChange={(e) => setForm({ ...form, shop_name: e.target.value })}
              placeholder="Al-Madina Mobiles"
              data-testid="register-shop-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              required
              minLength={6}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="At least 6 characters"
              data-testid="register-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
            data-testid="register-submit-btn"
          >
            {loading ? "Creating..." : "Create shop"}
          </Button>
          <div className="text-sm text-slate-600 text-center">
            Already have an account?{" "}
            <Link to="/login" className="text-emerald-700 font-semibold" data-testid="to-login-link">
              Log in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
